<template>
    <div class="plate">
        <div class="plate-country-code-band">{{ countryCode }}</div>
        <div class="plate-number">{{ number }}</div>
    </div>
</template>

<script>

export default {
    name: "plate",
    components: {},
    props: {
        countryCode: {type: String},
        number: {type: String},
    },
}
</script>

<style>
.plate {
    display: flex;
    height: 30px;
    width: max-content;
    border: 2px solid #000000;
    border-radius: 4px;
    overflow: hidden;
    font-family: Arial, sans-serif;
    text-transform: uppercase;
}

.plate .plate-country-code-band {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    height: 100%;
    width: 12px;
    background: #0020a4;
    font-size: 6px;
    font-weight: 600;
    line-height: 1;
    color: #ffffff;
    padding-bottom: 4px;
}

.plate .plate-number {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 0 5px;
    background: #ffffff;
    font-size: 20px;
    line-height: 1;
    font-weight: 500;
    color: #000000;
}
</style>